<div
    [@showOpacityAnimation]="animState"
    (@showOpacityAnimation.done)="whenAnimate($event)"
    class="reg__wrapper"
>
    <form class="reg-form" [formGroup]="frmReg">
        <div class="loading-group">
            <div *ngIf="loading" class="loading">
                <loader color="#fff" [isFullscreen]="true"> </loader>
            </div>

            <ng-container
                *ngFor="
                    let fieldName of createPatientListParamsR;
                    let i = index
                "
            >
                <ng-container [ngSwitch]="true">
                    <ng-container *ngSwitchCase="fieldName === 'razdel'">
                        <div class="cls-block-razdel"></div>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'lastName' ||
                            fieldName === 'lastName*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <input
                                [type]="'text'"
                                matInput
                                formControlName="lastName"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                                (keydown.enter)="moveToNextField($event)"
                                #inputField
                            />
                            <mat-label>Фамилия</mat-label>
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'firstName' ||
                            fieldName === 'firstName*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <input
                                [type]="'text'"
                                matInput
                                formControlName="firstName"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                                (keydown.enter)="moveToNextField($event)"
                                #inputField
                            />
                            <mat-label>Имя</mat-label>
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'secondName' ||
                            fieldName === 'secondName*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <mat-label>Отчество</mat-label>
                            <input
                                [type]="'text'"
                                matInput
                                formControlName="secondName"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                                (keydown.enter)="moveToNextField($event)"
                                #inputField
                            />
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'sex' || fieldName === 'sex*'
                        "
                    >
                        <div class="gender-choice-container">
                            <button
                                class="man"
                                (click)="gender($event, 0)"
                                type="button"
                            >
                                <img
                                    style="pointer-events: none"
                                    src="./assets/img/svg/auth/man.svg"
                                    alt="Мужчина"
                                />
                            </button>
                            <button
                                class="woman"
                                (click)="gender($event, 1)"
                                type="button"
                            >
                                <img
                                    style="pointer-events: none"
                                    src="./assets/img/svg/auth/women.svg"
                                    alt="Женщина"
                                />
                            </button>
                        </div>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'birthDate' ||
                            fieldName === 'birthDate*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <mat-label>Дата рождения</mat-label>
                            <input
                                type="date"
                                matInput
                                formControlName="birthDate"
                                required="true"
                                [max]="maxDate"
                                [readonly]="loading"
                                (keydown)="onDateKeydownHandler($event)"
                                (keydown.enter)="moveToNextField($event)"
                                #inputField
                            />
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'snils' || fieldName === 'snils*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <mat-label>Снилс</mat-label>
                            <input
                                [type]="'text'"
                                matInput
                                placeholder="XXX-XXX-XXX XX"
                                snilsMask
                                [preValue]="frmReg.value.snils"
                                maxlength="14"
                                formControlName="snils"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                                (keydown.enter)="moveToNextField($event)"
                                (input)="onInputRestrict($event, 14)"
                                #inputField
                            />
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'email' || fieldName === 'email*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <mat-label>Почта</mat-label>
                            <input
                                [type]="'text'"
                                matInput
                                placeholder="guest@mail.ru"
                                formControlName="email"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                                (keydown.enter)="moveToNextField($event)"
                                #inputField
                            />
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'phone' || fieldName === 'phone*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <mat-label>Телефон</mat-label>
                            <span matTextPrefix>+7 &nbsp;</span>
                            <input
                                [type]="'text'"
                                matInput
                                placeholder="(999) 999-9999"
                                formControlName="phone"
                                phoneMask
                                [preValue]="frmReg.value.phone"
                                maxlength="14"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                                (keydown.enter)="moveToNextField($event)"
                                #inputField
                                (input)="onInputRestrict($event, 14)"
                            />
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'inn' || fieldName === 'inn*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <input
                                [type]="'text'"
                                matInput
                                placeholder="ИНН"
                                formControlName="inn"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                            />
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'iin' || fieldName === 'iin*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <mat-label>ИИН</mat-label>
                            <input
                                [type]="'text'"
                                matInput
                                formControlName="iin"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                                (keydown.enter)="moveToNextField($event)"
                                #inputField
                            />
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'card' || fieldName === 'card*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <mat-label>Номер карты пациента</mat-label>
                            <input
                                [type]="'text'"
                                matInput
                                formControlName="card"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                            />
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'tabNum' || fieldName === 'tabNum*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <mat-label>Табельный номер</mat-label>
                            <input
                                [type]="'text'"
                                matInput
                                formControlName="tabNum"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                            />
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'polisNum' ||
                            fieldName === 'polisNum*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <input
                                [type]="'text'"
                                matInput
                                placeholder="Полис номер"
                                formControlName="polisNum"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                            />
                        </mat-form-field>
                    </ng-container>

                    <ng-container
                        *ngSwitchCase="
                            fieldName === 'polisSer' ||
                            fieldName === 'polisSer*'
                        "
                    >
                        <mat-form-field class="w-100">
                            <input
                                [type]="'text'"
                                matInput
                                placeholder="Полис серия"
                                formControlName="polisSer"
                                [readonly]="loading"
                                (keydown.space)="$event.preventDefault()"
                                [required]="requiredField(fieldName)"
                            />
                        </mat-form-field>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="listAuth">
                <div class="reg-form_acception">
                    <div class="acception__item">
                        <input
                            #checkboxPd
                            type="checkbox"
                            id="acception_pd"
                            [checked]="isPdAccepted"
                            (change)="checkAcception($event, 'pd')"
                            class="custom-checkbox"
                        />
                        <label for="acception_pd" class="checkbox-label">
                            <span class="checkbox-custom"></span>
                            <span class="checkbox-text">
                                Согласен с
                                <a
                                    href="javascript:void(0)"
                                    (click)="clickAcceptPd()"
                                    class="link-document"
                                >
                                    политикой в отношении персональных данных
                                </a>
                            </span>
                        </label>
                    </div>

                    <div class="acception__item">
                        <input
                            #checkboxLk
                            type="checkbox"
                            id="acception_lk"
                            [checked]="isLkAccepted"
                            (change)="checkAcception($event, 'lk')"
                            class="custom-checkbox"
                        />
                        <label for="acception_lk" class="checkbox-label">
                            <span class="checkbox-custom"></span>
                            <span class="checkbox-text">
                                Согласен с
                                <a
                                    href="javascript:void(0)"
                                    (click)="clickAcceptLs()"
                                    class="link-document"
                                >
                                    условиями использования сервиса личного
                                    кабинета
                                </a>
                            </span>
                        </label>
                    </div>
                </div>
            </ng-container>

            <div class="phone__captcha captcha">
                <div class="captcha__left">
                    <mat-form-field class="input">
                        <input
                            type="number"
                            id="regcaptha"
                            matInput
                            placeholder="Введите код с картинки"
                            maxlength="4"
                            formControlName="captcha"
                            [readonly]="loading || captchaLoading"
                            (keydown.space)="$event.preventDefault()"
                            required
                            (keypress)="numberOnly($event)"
                        />
                    </mat-form-field>
                </div>
                <div class="captcha__right">
                    <div
                        *ngIf="captcha; else captchaLoader"
                        class="captcha-content"
                    >
                        <!-- Контейнер для SVG капчи -->
                        <div
                            class="captcha__img"
                            [innerHTML]="captcha.svg | safe : 'html'"
                        ></div>

                        <!-- Кнопка обновления капчи -->
                        <button
                            class="captcha__refresh"
                            type="button"
                            (click)="refreshCaptcha()"
                        >
                            <mat-icon svgIcon="refresh"></mat-icon>
                        </button>
                    </div>

                    <ng-template #captchaLoader>
                        <div class="loader-wrapper">
                            <span class="loader"></span>
                        </div>
                    </ng-template>
                </div>
            </div>
            <button
                class="w-100 btn cls-btn cls-btn-reg"
                type="submit"
                [disabled]="loading || !frmReg.valid || notAcceptedCounter > 0"
                (click)="reg()"
            >
                <!-- *ngIf="!loading; else loaderBtn" -->
                <span> Зарегистрироваться </span>
            </button>

            <div class="cls-txt-center cls-footer1">Есть аккаунт?</div>
            <div
                class="cls-txt-center cls-footer2"
                (click)="goAuth()"
                placeholder="Регистрация"
            >
                <!-- <mat-icon
                    class="cls-icon-arrow-right"
                    svgIcon="arrow_left"
                ></mat-icon
                > -->
                Войти
            </div>
        </div>
    </form>
</div>

<ng-template #loader>
    <loader color="#1A8DCC" [isFullscreen]="true"></loader>
</ng-template>
<!-- 
<ng-template #loaderBtn>
    <loader color="#fff" [isFullscreen]="true"></loader>
</ng-template> -->
